import cookie from "react-cookies";

export default function () {
    if (cookie.load('customer_id') === '' || cookie.load('customer_id') === undefined || cookie.load('customer_id') === null) {
        return false;
    } else {
        return true;
    }
}